import { Box, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IRepeaterItem } from './Repeater';
import React from 'react';

interface RepeaterItemProps<T extends IRepeaterItem> {
  item: T;
  index: number;
  Form: JSX.Element;
  onDeleteItem: (index: number) => void;
  onEditClicked?: (index: number) => void;
  onItemSave: (data: T, index: number) => void;
  children?: React.ReactNode;
  titleField?: string;
  subTitleField?: string;
}

const RepeaterItem = <T extends IRepeaterItem>(props: RepeaterItemProps<T>) => {
  const { item, index, onDeleteItem, onEditClicked, Form, titleField, subTitleField } = props;

  const handleEditItem = () => {
    onEditClicked(index);
  };

  const onSave = (data: T) => {
    props.onItemSave(data, index);
  };

  return (
    <div className={`repeater-item ${item.inEdit ? 'in-edit' : ''}`}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box className="repeater-item__left-side">
          <p>
            <b>{item[titleField]}</b> {item[subTitleField] ? '- ' : ''} {item[subTitleField]}
          </p>
        </Box>
        <Box className="repeater-item__right-side">
          <div className="repeater-item__right-side__container">
            <IconButton aria-label="edit" onClick={() => handleEditItem()} className="repeater-item__edit-btn">
              <EditIcon />
            </IconButton>
            <IconButton aria-label="delete" onClick={() => onDeleteItem(index)}>
              <DeleteIcon />
            </IconButton>
          </div>
        </Box>
      </Box>

      {/* Render the FORM if in edit mode */}
      <div className="repeater-item__content" style={{ display: item.inEdit ? 'block' : 'none' }}>
        {React.cloneElement(Form, { onSave: onSave, data: item })}
      </div>
    </div>
  );
};

export default RepeaterItem;
